import {Component, Input, OnInit} from '@angular/core';
import {BsModalService} from "ngx-bootstrap";

@Component({
  selector: 'app-additional-reservation-data',
  templateUrl: './additional-reservation-data.component.html',
  styleUrls: ['./additional-reservation-data.component.scss']
})
export class AdditionalReservationDataComponent implements OnInit {
  @Input() reservation:any;
  constructor(private modalService:BsModalService) { }

  ngOnInit() {
  }

  goToReservation() {
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    if(this.reservation.type == 'DELIVERY'){
      window.location.href = '#/reservations/delivery/'+this.reservation.restaurantHistoryId+'/'+this.reservation.id;
    }
    window.location.href = '#/reservations/restaurant/'+this.reservation.restaurantHistoryId+'/'+this.reservation.id;
  }
}
